<template>
  <div class="App-contact bg-white">
    <div class="inner inner-narrow text-center">
      <div class="content">
        <div class="form">
          <transition :name="transitionName" mode="out-in">
            <router-view class="router-view"></router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const INQUIRY = [
    {
      id: 'job',
      title: 'への求人掲載について'
    },
    {
      id: 'register',
      title: 'をお持ちの方の登録方法について'
    },
    {
      id: 'other',
      title: 'その他'
    }
  ]
  const CUSTOM_INQUIRY = 'other'
  const DEFAULT_INQUIRY = 'job'
  const LOCAL_STORAGE_KEY = 'contactData'

  export default {
    provide: {
      'INQUIRY': INQUIRY,
      'CUSTOM_INQUIRY': CUSTOM_INQUIRY,
      'DEFAULT_INQUIRY': DEFAULT_INQUIRY,
      'LOCAL_STORAGE_KEY': LOCAL_STORAGE_KEY
    },
    computed: {
      transitionName() {
        return this.$route.meta.transitionName
      },
    }
  }
</script>
<style scoped>
  .fade-enter-active {
    transition: all .3s ease;
  }
  .fade-leave-active {
    transition: all .3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
